
<form [formGroup]="formBuilder">
    <div class="block w-100 datatable dataTables_wrapper">
        <table aria-describedby=""  class="table table-responsive">
            <thead>
                <tr class="back-white text-center my-3">
                    <th class="border-bottom-0">Giorno</th>
                    <th class="border-bottom-0">Mattina</th>
                    <th class="border-bottom-0">Pomeriggio</th>
                    <th class="border-bottom-0" *ngIf="!isOnlyView">Chiusura</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="label-fw">Lunedì</td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120"  [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="monMFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.monMFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMFrom('mon')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.monMFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.monMFrom.value!==''">{{formControls.monMFrom.value}}</span>
                                    <span *ngIf="formControls.monMFrom.value===''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="monMTo" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.monMTo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMTo('mon')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.monMTo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.monMTo.value!=''">{{formControls.monMTo.value}}</span>
                                    <span *ngIf="formControls.monMTo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="monEFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.monEFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeEFrom('mon')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.monEFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.monEFrom.value!=''">{{formControls.monEFrom.value}}</span>
                                    <span *ngIf="formControls.monEFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="monETo" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.monETo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeETo('mon')"
                                        
                                        >
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.monETo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.monETo.value!=''">{{formControls.monETo.value}}</span>
                                    <span *ngIf="formControls.monETo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td *ngIf="!isOnlyView">
                        <div class="text-center">
                            <label class="switch">
                                <input  type="checkbox" 
                                        [value]="OpeningclosinghoursView.monApertura" 
                                        (change)="toggleApertura('mon')"
                                        [checked]="OpeningclosinghoursView.monApertura == false">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="label-fw">Martedì</td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="tueMFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.tueMFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMFrom('tue')"
                                        >
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.tueMFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.tueMFrom.value!=''">{{formControls.tueMFrom.value}}</span>
                                    <span *ngIf="formControls.tueMFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="tueMTo" 
                                        class="form-time form-control"
                                        [ngClass]="{'is-invalid': formControls.tueMTo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMTo('tue')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.tueMTo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.tueMTo.value!=''">{{formControls.tueMTo.value}}</span>
                                    <span *ngIf="formControls.tueMTo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="tueEFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.tueEFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeEFrom('tue')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.tueEFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.tueEFrom.value!=''">{{formControls.tueEFrom.value}}</span>
                                    <span *ngIf="formControls.tueEFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="tueETo" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.tueETo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeETo('tue')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.tueETo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.tueETo.value!=''">{{formControls.tueETo.value}}</span>
                                    <span *ngIf="formControls.tueETo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td *ngIf="!isOnlyView">
                        <div class="text-center">
                            <label class="switch">
                                <input  type="checkbox" 
                                        [value]="OpeningclosinghoursView.tueApertura" 
                                        (change)="toggleApertura('tue')"
                                        [checked]="OpeningclosinghoursView.tueApertura == false">
                                <span class="slider round"></span>    
                            </label>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="label-fw">Mercoledì</td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="wedMFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.wedMFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMFrom('wed')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.wedMFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.wedMFrom.value!=''">{{formControls.wedMFrom.value}}</span>
                                    <span *ngIf="formControls.wedMFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="wedMTo" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.wedMTo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMTo('wed')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.wedMTo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.wedMTo.value!=''">{{formControls.wedMTo.value}}</span>
                                    <span *ngIf="formControls.wedMTo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="wedEFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.wedEFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeEFrom('wed')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.wedEFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.wedEFrom.value!=''">{{formControls.wedEFrom.value}}</span>
                                    <span *ngIf="formControls.wedEFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="wedETo" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.wedETo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeETo('wed')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.wedETo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.wedETo.value!=''">{{formControls.wedETo.value}}</span>
                                    <span *ngIf="formControls.wedETo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                        </div>
                    </td>
                    <td *ngIf="!isOnlyView">
                        <div class="text-center">
                            <label class="switch">
                                <input  type="checkbox" 
                                        [value]="OpeningclosinghoursView.wedApertura" 
                                        (change)="toggleApertura('wed')"
                                        [checked]="OpeningclosinghoursView.wedApertura == false">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="label-fw">Giovedì</td>
                     <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="thuMFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.thuMFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMFrom('thu')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.thuMFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.thuMFrom.value!=''">{{formControls.thuMFrom.value}}</span>
                                    <span *ngIf="formControls.thuMFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="thuMTo" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.thuMTo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMTo('thu')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.thuMTo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.thuMTo.value!=''">{{formControls.thuMTo.value}}</span>
                                    <span *ngIf="formControls.thuMTo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="thuEFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.thuEFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeEFrom('thu')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.thuEFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.thuEFrom.value!=''">{{formControls.thuEFrom.value}}</span>
                                    <span *ngIf="formControls.thuEFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="thuETo"
                                        class="form-time form-control"
                                        [ngClass]="{'is-invalid': formControls.thuETo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeETo('thu')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.thuETo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.thuETo.value!=''">{{formControls.thuETo.value}}</span>
                                    <span *ngIf="formControls.thuETo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td *ngIf="!isOnlyView">
                        <div class="text-center">
                            <label class="switch">
                                <input  type="checkbox" 
                                        [value]="OpeningclosinghoursView.thuApertura" 
                                        (change)="toggleApertura('thu')"
                                        [checked]="OpeningclosinghoursView.thuApertura == false">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="label-fw">Venerdì</td>
                   <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="friMFrom" 
                                        class="form-time form-control"  
                                        [ngClass]="{'is-invalid': formControls.friMFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMFrom('fri')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.friMFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.friMFrom.value!=''">{{formControls.friMFrom.value}}</span>
                                    <span *ngIf="formControls.friMFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="friMTo" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.friMTo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMTo('fri')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.friMTo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.friMTo.value!=''">{{formControls.friMTo.value}}</span>
                                    <span *ngIf="formControls.friMTo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                        </div>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="friEFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.friEFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeEFrom('fri')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.friEFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.friEFrom.value!=''">{{formControls.friEFrom.value}}</span>
                                    <span *ngIf="formControls.friEFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="friETo" 
                                        class="form-time form-control"
                                        [ngClass]="{'is-invalid': formControls.friETo.status === 'INVALID' && form.touched === true}" 
                                        aria-label="form-select-sm" 
                                        (change)="changeETo('fri')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.friETo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>
                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.friETo.value!=''">{{formControls.friETo.value}}</span>
                                    <span *ngIf="formControls.friETo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                        </div>
                    </td>
                    <td *ngIf="!isOnlyView">
                        <div class="text-center">
                            <label class="switch">
                                <input  type="checkbox" 
                                        [value]="OpeningclosinghoursView.friApertura" 
                                        (change)="toggleApertura('fri')"
                                        [checked]="OpeningclosinghoursView.friApertura == false">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="label-fw">Sabato</td>
                   <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="satMFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.satMFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMFrom('sat')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.satMFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.satMFrom.value!=''">{{formControls.satMFrom.value}}</span>
                                    <span *ngIf="formControls.satMFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="satMTo" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.satMTo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMTo('sat')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.satMTo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.satMTo.value!=''">{{formControls.satMTo.value}}</span>
                                    <span *ngIf="formControls.satMTo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="satEFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.satEFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm"
                                        (change)="changeEFrom('sat')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.satEFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.satEFrom.value!=''">{{formControls.satEFrom.value}}</span>
                                    <span *ngIf="formControls.satEFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="satETo" 
                                        class="form-time form-control"
                                        [ngClass]="{'is-invalid': formControls.satETo.status === 'INVALID' && form.touched === true}" 
                                        aria-label="form-select-sm" 
                                        (change)="changeETo('sat')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.satETo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>
                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.satETo.value!=''">{{formControls.satETo.value}}</span>
                                    <span *ngIf="formControls.satETo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td *ngIf="!isOnlyView">
                        <div class="text-center">
                            <label class="switch">
                                <input  type="checkbox" 
                                        [value]="OpeningclosinghoursView.satApertura" 
                                        (change)="toggleApertura('sat')"
                                        [checked]="OpeningclosinghoursView.satApertura == false">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="label-fw">Domenica</td>
                     <td>
                        <div class="row">
                            <div class="col d-flex align-items-center" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="sunMFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.sunMFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMFrom('sun')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.sunMFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>
                            <div class="col d-flex align-items-center " [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.sunMFrom.value!=''">{{formControls.sunMFrom.value}}</span>
                                    <span *ngIf="formControls.sunMFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="sunMTo" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.sunMTo.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeMTo('sun')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.sunMTo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>
                            <div class="col d-flex align-items-center " [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.sunMTo.value!=''">{{formControls.sunMTo.value}}</span>
                                    <span *ngIf="formControls.sunMTo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-2">Dalle: </span>
                                <select formControlName="sunEFrom" 
                                        class="form-time form-control" 
                                        [ngClass]="{'is-invalid': formControls.sunEFrom.status === 'INVALID' && form.touched === true}"
                                        aria-label="form-select-sm" 
                                        (change)="changeEFrom('sun')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.sunEFrom" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Dalle: </span>
                                    <span *ngIf="formControls.sunEFrom.value!=''">{{formControls.sunEFrom.value}}</span>
                                    <span *ngIf="formControls.sunEFrom.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>

                            <div class="col d-flex align-items-center col-120" [hidden]="isOnlyView">
                                <span class="me-3">Alle: </span>
                                <select formControlName="sunETo" 
                                        class="form-time form-control"
                                        [ngClass]="{'is-invalid': formControls.sunETo.status === 'INVALID' && form.touched === true}" 
                                        aria-label="form-select-sm" 
                                        (change)="changeETo('sun')">
                                    <option value="" selected>--:--</option>
                                    <option *ngFor="let opt of OpeningclosinghoursView.sunETo" value="{{opt}}">{{opt}}</option>
                                </select>
                            </div>
                            
                            <div class="col d-flex align-items-center col-120" [hidden]="!isOnlyView">
                                <div class="form-time">
                                    <span class="me-3">Alle: </span>
                                    <span *ngIf="formControls.sunETo.value!=''">{{formControls.sunETo.value}}</span>
                                    <span *ngIf="formControls.sunETo.value==''" >--:--</span>
                                    <i class="fal fa-clock" ></i>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td *ngIf="!isOnlyView">
                        <div class="text-center">
                            <label class="switch">
                                <input  type="checkbox" 
                                        [value]="OpeningclosinghoursView.sunApertura" 
                                        (change)="toggleApertura('sun')"
                                        [checked]="OpeningclosinghoursView.sunApertura == false">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    
    <div class="label-fw my-3" 
        *ngIf="isVisibleNote">
        Note
    </div>
    <div class="row mx-1"
        *ngIf="isVisibleNote">
        <textarea id="note" formControlName="note" name="note" rows="3" (change)="changeValue()"></textarea>
    </div>
</form>

